import { sendAndListenOnce } from './utils';
export class IframeDirectSigner {
    chainId;
    constructor(chainId) {
        this.chainId = chainId;
    }
    async getAccounts(...params) {
        return await sendAndListenOnce({
            method: 'signer:getAccounts',
            params,
            chainId: this.chainId,
            signType: 'direct',
        }, async (data) => {
            if (data.type === 'success') {
                return data.response;
            }
            else {
                throw new Error(data.error);
            }
        });
    }
    async signDirect(...params) {
        return await sendAndListenOnce({
            method: 'signer:signDirect',
            params,
            chainId: this.chainId,
            signType: 'direct',
        }, async (data) => {
            if (data.type === 'success') {
                return data.response;
            }
            else {
                throw new Error(data.error);
            }
        });
    }
}
export class IframeAminoSigner {
    chainId;
    constructor(chainId) {
        this.chainId = chainId;
    }
    async getAccounts(...params) {
        return await sendAndListenOnce({
            method: 'signer:getAccounts',
            params,
            chainId: this.chainId,
            signType: 'amino',
        }, async (data) => {
            if (data.type === 'success') {
                return data.response;
            }
            else {
                throw new Error(data.error);
            }
        });
    }
    async signAmino(...params) {
        return await sendAndListenOnce({
            method: 'signer:signAmino',
            params,
            chainId: this.chainId,
            signType: 'amino',
        }, async (data) => {
            if (data.type === 'success') {
                return data.response;
            }
            else {
                throw new Error(data.error);
            }
        });
    }
}
//# sourceMappingURL=signers.js.map